import React from 'react';
import cn from 'classnames';
import {StandardProps} from '..';

export type DialogActionsProps = StandardProps;

export const DialogActions: React.FC<DialogActionsProps> = ({className, children, ...restProps}) => {
  return (
    <div
      className={cn(
        'dialog__actions',
        'p-5 p-sm-6 gap-3',
        className,
      )}
      {...restProps}
    >
      {children}
    </div>
  );
};

export default DialogActions;
